import { Galleries } from '../../../../common/types/api/page'

export function addGallery(id: number): Galleries {
    return {
        id,
        columns: [],
        fileName: `file_${id}`,
        style: {
            backgroundColor: '',
            borderColor: '',
            borderStyle: '',
            borderWidth: ''
        }
    }
}
